package navigation.home.contact

import org.koin.core.qualifier.named
import org.koin.dsl.module

val ContactUiModule
    get() =
        module {
            factory {
                ContactScreenModel(
                    contactRepository = get(),
                    loadingManager = get(),
                )
            }

            fun contactScreenModel(name: String) =
                factory(named(name)) {
                    ContactScreenModel(
                        contactRepository = get(),
                        loadingManager = get(),
                    )
                }

            contactScreenModel("supplier")
            contactScreenModel("travelAgent")
            contactScreenModel("itineraryService")
        }